import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectFacebook } from './useConnectFacebook'
import { useConnectInstagram } from './useConnectInstagram'
import { ConnectProps, useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useInitiateOauth } from 'hooks/useInitiateOauth'

interface Props extends ConnectProps {
  isSingleSelect?: boolean
  allowReconnect?: boolean
}

export const useConnectAccount = ({ isSingleSelect, allowReconnect, onConnect, onIntegrationAuthCreated }: Props) => {
  const { connect } = useConnectAccountPopup({ isSingleSelect, allowReconnect })
  const connectFacebook = useConnectFacebook({ onConnect, isSingleSelect, allowReconnect, onIntegrationAuthCreated })
  const connectInstagram = useConnectInstagram({ onConnect, isSingleSelect, allowReconnect, onIntegrationAuthCreated })
  const { initiateOauth } = useInitiateOauth()

  return async (provider: ExternalIntegrationEnum) => {
    if (provider === ExternalIntegrationEnum.Facebook) {
      connectFacebook()
      return
    }

    if (provider === ExternalIntegrationEnum.Instagram) {
      connectInstagram()
      return
    }

    const popup = await initiateOauth(provider, undefined, '_blank', 'popup=true,width=600,height=780')
    if (!popup) {
      return
    }
    connect(popup, { onConnect, onIntegrationAuthCreated })
  }
}
